import { styled } from '@mui/material/styles';
import {Tooltip} from "@mui/material";


const InfoTooltip = styled(Tooltip)({
    //ABANDONED BUT WILL USE
});


export default InfoTooltip;